import { MenuItem } from '../contentful/contentfulClient';

export interface MenuState {
    menuItems: Array<MenuItem>;
    loaded: boolean;
    loading: boolean;
    expanded: boolean;
}

export const menuInitialState: MenuState = {
    menuItems: [],
    loaded: false,
    loading: false,
    expanded: false,
};


// WEBPACK FOOTER //
// ./src/menu/MenuState.ts